// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__3ENkM","spin":"Spinner_spin__2cA5G","container":"Spinner_container__3wPbR"};